import View from './view'
import { useIsDisabled } from './helpers.js'

export default function Logic(props) {
  let disabled = useIsDisabled(props)

  return <View {...props} disabled={disabled} />
}
